import { ApiCore } from "@/services/api/utils/core.js";
import { apiProvider } from "@/services/api/utils/provider.js";
import axios from "axios";
import { handleError, handleResponse } from "@/services/api/utils/response.js";

const url = "v1/settings";

class SettingApi extends ApiCore {
	constructor(options) {
		super(options);
	}

	getNotifications = (options = {}) => {
		const { setLoading, addToastMessage } = options;
		if (setLoading) {
			setLoading(true);
		}
		return axios
			.get(`${apiProvider.BASE_URL}/${url}/user-notifications`)
			.then((res) => handleResponse(res))
			.catch((err) => {
				if (addToastMessage) {
					const msg = "Failed to get notification settings";
					addToastMessage(msg, "error");
				}
				return handleError(err);
			})
			.finally(() => {
				if (setLoading) {
					setLoading(false);
				}
			});
	};

	updateNotifications = (payload, options = {}) => {
		const { setLoading, addToastMessage } = options;
		if (setLoading) {
			setLoading(true);
		}
		return axios
			.put(`${apiProvider.BASE_URL}/${url}/user-notifications`, payload)
			.then((res) => handleResponse(res))
			.catch((err) => {
				if (addToastMessage) {
					const msg = "Failed to update notification settings";
					addToastMessage(msg, "error");
				}
				return handleError(err);
			})
			.finally(() => {
				if (setLoading) {
					setLoading(false);
				}
			});
	};
}

export const settingApi = new SettingApi({ url });
